import { getAllLanguages, getLanguageCode, getUrlLanguageCode } from '@/i18n/languageMapping'

export type Language = {
	code: string
	name: string
	englishName: string
	flag: string
}

export const getLanguages = (): Language[] => {
	return getAllLanguages().map((lang) => ({
		code: getUrlLanguageCode(lang.code),
		name: lang.nativeName,
		englishName: lang.name,
		flag: lang.flag,
		folder: lang.folder,
		nativeName: lang.nativeName,
	}))
}

export const kayakLanguageMap = {
	he: 'iw',
	cz: 'cs',
	gr: 'el',
}
export const getKayakLanguageCode = (lang: string): string => kayakLanguageMap[lang as keyof typeof kayakLanguageMap] || getLanguageCode(lang)